import React, { useState, useEffect, useRef } from 'react';
import {
  Tabs,
  Tab,
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';
import { setImage, getImage, getAllImages } from '../../lib/idb';

export default function Handler(props) {
  const { formData, setFormData } = props;

  const [currentTab, setCurrentTab] = useState(0);
  const fileInputRef = useRef(null);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // local state
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [images, setImages] = useState([]);

  // effects
  useEffect(() => {
    const fetchImages = async () => {
      const storedImages = await getAllImages();
      const imageUrls = storedImages.map((image) => ({
        name: image.name,
        url: URL.createObjectURL(image),
      }));
      setImages(imageUrls);

      // clean up (on unmount)
      return () => {
        imageUrls.forEach((url) => URL.revokeObjectURL(url));
      };
    };

    fetchImages();
  }, []);
  useEffect(() => {
    const loadImage = async () => {
      const image = await getImage(fileName);
      setImages([
        ...images,
        { name: image.name, url: URL.createObjectURL(image) },
      ]);
    };

    if (fileName) {
      loadImage();
    }
  }, [fileName]);

  // handlers
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const handleUpload = async () => {
    if (file) {
      await setImage(file.name, file);
      setFileName(file.name);

      // reset
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <Tabs
        value={currentTab}
        onChange={(e, value) => setCurrentTab(value)}
        aria-label="basic tabs example"
      >
        <Tab label="URL" id="tab-url" />
        <Tab label="Uploads" id="tab-upload" />
      </Tabs>
      <Box value={currentTab} index={0} hidden={currentTab !== 0}>
        <TextField
          fullWidth
          size="small"
          value={formData.image || ''}
          name="image"
          label="Image URL"
          helperText="Please use SVG or low resolution PNG (64x64) for improved performance"
          onChange={handleChange}
          required
        />
      </Box>
      <Box value={currentTab} index={1} hidden={currentTab !== 1}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Select
            name="image"
            labelId="image-select"
            value={formData.image || ''}
            label="Image"
            onChange={handleChange}
            sx={{ flexGrow: 1, mr: 5 }}
          >
            <MenuItem value={formData.image || ''}>
              <Box display="flex" alignItems="center">
                {/* formData.image && (
                  <img
                    src={formData.image}
                    alt="Current"
                    style={{ maxWidth: 50, maxHeight: 50, marginRight: 10 }}
                  />
                ) */}
                <Typography><em>Select Image</em></Typography>
              </Box>
            </MenuItem>
            {images.map((image) => (
              <MenuItem value={image.url} key={`image-${image.name}`}>
                <Box display="flex" alignItems="center">
                  <img
                    src={image.url}
                    alt={image.name}
                    style={{ maxWidth: 50, maxHeight: 50, marginRight: 10 }}
                  />
                  <Typography>{image.name}</Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
          <Box>
            <input
              type="file"
              onChange={handleFileChange}
              accept="image/*"
              ref={fileInputRef}
            />
            <Button variant="outlined" size="small" onClick={handleUpload}>
              Upload
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
/*
```md
[URL: createObjectURL() static method](https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL_static)

> **The URL lifetime is tied to the document in the window on which it was created**. The new
object URL represents the specified File object or Blob object.

I.e we can't save the URL, have to save the filename (key).
```
*/
